import { render, staticRenderFns } from "./LqsCard.vue?vue&type=template&id=761397bc&scoped=true"
import script from "./LqsCard.vue?vue&type=script&lang=js"
export * from "./LqsCard.vue?vue&type=script&lang=js"
import style0 from "./LqsCard.vue?vue&type=style&index=0&id=761397bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761397bc",
  null
  
)

export default component.exports